export default __webpack_public_path__ + "static/media/logo-mediline-white.361e05c7.svg";